<template>
  <Table
    :rows="rows"
    :columns="filteredColumns"
    columnID="idLiquidacionDetalle"
    :containerClass="'m-0'"
  >
    <template #tfooter>
      <tfoot>
        <tr
          v-for="(total, moneda) in total"
          :key="moneda"
          class="table-secondary"
        >
          <td class="text-right" colspan="5">
            <strong>TOTAL {{ moneda }}</strong>
          </td>
          <td class="text-right">
            <strong>{{ total | number(2) }}</strong>
          </td>
          <td v-if="existsObservaciones"></td>
        </tr>
      </tfoot>
    </template>
  </Table>
</template>

<script>
import Table from "../../shared/components/Table.vue";
export default {
  components: { Table },
  props: {
    rows: Array,
    columns: {
      type: Array,
      default() {
        return [
          "fecha",
          "servicio",
          "hotel",
          "tipo",
          "moneda",
          "monto",
          "observaciones"
        ];
      }
    },
    total: Object
  },
  data() {
    return {
      inner: {
        columns: [
          {
            key: "fecha",
            label: "Fecha",
            width: 60,
            head_class: "text-center",
            row_class: "text-center"
          },
          {
            key: "servicio",
            width: 300
          },
          {
            key: "hotel",
            width: 250
          },
          {
            key: "tipo",
            label: "Tipo",
            width: 50,
            head_class: "text-center",
            row_class: "text-center"
          },
          {
            key: "moneda",
            label: "Moneda",
            width: 60,
            head_class: "text-center",
            row_class: "text-center"
          },
          {
            key: "monto",
            label: "Monto",
            width: 60,
            head_class: "text-center",
            row_class: "text-right"
          },
          {
            key: "observaciones",
            width: 300
          }
        ]
      }
    };
  },
  computed: {
    filteredColumns() {
      return this.inner.columns.filter(item => this.columns.includes(item.key));
    },
    existsObservaciones() {
      return this.columns.some(item => item == "observaciones");
    }
  }
};
</script>

<style></style>
